import React from 'react';

import Button from '../commons/component/button';

class CustomerConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: props.email };
    this.onConfirm = props.onConfirm;
    this.closePopUp = props.closePopUp;
  }

  render() {
    return (
      <div className="customer-confirm-popup">
        <div className="email">
          <label>E-mail:</label>
          <b>{this.state.email}</b>
        </div>
        <div>
          <Button onClick={this.closePopUp}>Voltar</Button>
          <Button primary onClick={this.onConfirm}>
            Continuar
          </Button>
        </div>
      </div>
    );
  }
}

export default CustomerConfirm;
